import exportSalesDictionary from '@src/features/export-sales/i18n/ru/export-sales.dic.json';

export const exportSales = {
  EXPORT_SALES: exportSalesDictionary,
};

export const exportSalesNamespaces = Object.keys(exportSales);
